import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import BottomSpacer from 'Components/ComponentLibrary/Components/Uncategorized/BottomSpacer';
import { useBodyBackgroundColor } from 'Hooks/useBodyBackgroundColor';

const styles = theme => ({
  root: {
    position: 'fixed',
    bottom: 0,
    width: '100%',
    zIndex: 1,
    backgroundColor: theme.palette.common.white,
  },
  content: {},
});

const FixedBottom = forwardRef(({
  className,
  classes,
  hasBottomNav,
}, ref) => {
  const backgroundColor = useBodyBackgroundColor();
  return (
    <div
      className={classNames(className, classes.root)}
      style={{ backgroundColor }}
    >
      <div
        className={classes.content}
        ref={ref}
      />
      {hasBottomNav && <BottomSpacer />}
    </div>
  );
});

FixedBottom.defaultProps = {
  className: '',
  hasBottomNav: true,
};

FixedBottom.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  offset: PropTypes.number,
  hasBottomNav: PropTypes.bool,
};

export default withStyles(styles)(FixedBottom);
